import { Flex, Text, theme } from '../2022-component-library';
import { Icon } from '../component-library';
import { useCalibration } from '../context/calibrationContext';
import { usePostMessage } from '../context/messageContext';
import { useTestContext } from '../context/testContext';
import { useBreakpoints } from '../helpers/useBreakpoints';
import styled from '@emotion/styled';

const PatientDistanceIndicator = ({ patientMoving, noRefresh }) => {
  const { testData } = useTestContext();
  const { sm, breakpoints } = useBreakpoints();
  const postMessage = usePostMessage();
  const {
    calibrationData: { distanceFromScreen },
  } = useCalibration();
  return (
    <Flex width='100%' border={`1px solid ${theme.colors.neutralLight}`} borderRadius='5px' minHeight={breakpoints('25px', '35px', '40px')}>
      <Flex alignItems='center' justifyContent='space-between' flex='1' backgroundColor='#EFEFEF' borderRadius='5px' padding='0 0.5rem'>
        <Text fontWeight='bold'>{`${sm ? '' : 'Patient'} Distance`}</Text>
        {!noRefresh && (
          <RecalculateDistanceButton
            shrink={sm}
            disabled={testData.testMode !== 'auto' || patientMoving}
            onClick={() => testData.testMode === 'auto' && postMessage({ type: 'recalculateDistance' })}
          />
        )}
      </Flex>
      <Flex width='30%' centered padding='0 0.5rem'>
        <Text fontWeight='bold'>{`${distanceFromScreen ? Math.round(distanceFromScreen) : '--'}mm`}</Text>
      </Flex>
    </Flex>
  );
};

const RecalculateDistanceContainer = styled(Flex)`
  background-color: ${(props) => (props.disabled ? 'lightgrey' : theme.colors.success)};
  width: ${({ shrink }) => (shrink ? '1.5em' : '2em')};
  aspect-ratio: 1;
  border-radius: 50%;
  z-index: 1;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 0.75;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  & svg {
    display: block !important;
  }
`;

const RecalculateDistanceButton = ({ ...props }) => {
  const { breakpoints } = useBreakpoints();
  return (
    <RecalculateDistanceContainer {...props}>
      <Icon icon='loop2' size={breakpoints(10, 12, 14)} color='white' />
    </RecalculateDistanceContainer>
  );
};

export default PatientDistanceIndicator;
